import { createContext } from 'react';

const StateProviderContext = createContext(null);
export default StateProviderContext;
